var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditLighter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8105 12.9996L13.417 5.39307L12.3565 4.33257L4.75 11.9391V12.9996H5.8105ZM6.43225 14.4996H3.25V11.3173L11.8263 2.74107C11.9669 2.60047 12.1576 2.52148 12.3565 2.52148C12.5554 2.52148 12.7461 2.60047 12.8868 2.74107L15.0085 4.86282C15.1491 5.00347 15.2281 5.1942 15.2281 5.39307C15.2281 5.59195 15.1491 5.78268 15.0085 5.92332L6.43225 14.4996ZM3.25 15.9996H16.75V17.4996H3.25V15.9996Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLighter);
export default __webpack_public_path__ + "static/media/edit-lighter.05532a6a0a57b3ad84419dd8856cc35b.svg";
export { ForwardRef as ReactComponent };